// src/components/das-application/SendPDFDialog.js
import React, { memo } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

function SendPDFDialog({
  open,
  onClose,
  email,
  handleEmailChange,
  emailError,
  handleConfirmSendEmail,
  isLoading,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Confirm Send PDF via Email</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Please enter the email address where you would like to receive your
          PDF application.
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="Email Address"
          type="email"
          fullWidth
          variant="outlined"
          value={email}
          onChange={handleEmailChange}
          error={Boolean(emailError)}
          helperText={emailError}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleConfirmSendEmail}
          color="primary"
          variant="contained"
          disabled={Boolean(emailError) || !email || isLoading}
          startIcon={isLoading && <CircularProgress size={20} />}
        >
          {isLoading ? "Sending..." : "Confirm Send Email"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(SendPDFDialog);
